//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';
import { jsonParse } from 'src_common/common/jsonParse';



export interface ParamsType {
    requestBody: {
        bonusId: string,
        id: null | undefined | number,
        maxFreebetAmountCents: number,
        minBetAmountCents: number,
        minDepositAmountCents: number,
        minimalOdds: number,
        name: string,
        promotionCode: string,
        universe: string,
        validFor: null | undefined | number,
        validUntil: null | undefined | string,
    },
}


const Response200IO = t.interface({
    bonusId: t.string,
    id: t.union([t.null, t.undefined, t.number]),
    maxFreebetAmountCents: t.number,
    minBetAmountCents: t.number,
    minDepositAmountCents: t.number,
    minimalOdds: t.number,
    name: t.string,
    promotionCode: t.string,
    universe: t.string,
    validFor: t.union([t.null, t.undefined, t.number]),
    validUntil: t.union([t.null, t.undefined, t.string]),
});

export type Response200Type = {
    bonusId: string,
    id: null | undefined | number,
    maxFreebetAmountCents: number,
    minBetAmountCents: number,
    minDepositAmountCents: number,
    minimalOdds: number,
    name: string,
    promotionCode: string,
    universe: string,
    validFor: null | undefined | number,
    validUntil: null | undefined | string,
};

export const decodeResponse200 = (data: unknown): Response200Type => {
    const decodeResult = Response200IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error /bonuses-ep/bonus-configuration -> put -> 200');
};






export const openapi_bonuses_putBonusesList = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType): Promise<FetchGeneralRawResponseType> => {
    const url = `${api_url}/bonuses-ep/bonus-configuration`;
    const method = 'PUT';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiBonusesPutBonusesListParamsType = ParamsType;

export type OpenapiBonusesPutBonusesListResponseType = {
    status: 200,
    body: Response200Type,
};

export type OpenapiBonusesPutBonusesListResponse200Type = Response200Type;

export const openapiBonusesPutBonusesListRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType): Promise<OpenapiBonusesPutBonusesListResponseType> => {
    const response = await openapi_bonuses_putBonusesList(api_url, api_timeout, backendToken, params);
    const { status, body } = response;
    const bodyParsed = jsonParse(body);

    if (bodyParsed.type === 'text') {
        throw Error(`Http status ${status} - json was expected`);
    }

    
    if (status === 200) {
        return {
            status: 200,
            body: decodeResponse200(bodyParsed.json)
        };
    }

    throw new Error(`openapiBonusesPutBonusesListRequest - unhandled response ${response.status}`);
};

